/** Step 7 “Review & start”. */
const wizReviewEN = {
  wizRevKeyJob: 'Role',
  wizRevCampaignName: 'Campaign “{{name}}”',
  wizRevKeyCandidates: 'Candidates',
  wizRevKeyBlacklist: 'Blacklist',
  wizRevKeyJudging: 'AI rating',
  wizRevKeyList: 'Candidate list',
  wizRevKeyApproach: 'Approach',
  wizRevKeyMessages: 'Messages',
  wizRevEdit: 'Edit',
  wizRevSaiaSearch: 'SAIA search',
  wizRevOwnSearch: 'Own LinkedIn search',
  wizRevOwnSearches_one: '{{count}} own LinkedIn search',
  wizRevOwnSearches_other: '{{count}} own LinkedIn searches',
  wizRevProfiles: 'approx. {{count}} profiles',
  wizRevNoLocation: 'no location',
  wizRevLocationUnconfirmed: '{{city}} (please confirm)',
  wizRevLocationWholeRegion: '{{city}} (whole region)',
  wizRevNoBlacklist: 'No blacklist active – known companies and contacts are not excluded.',
  wizRevBlacklistEntries: '{{count}} entries for this campaign',
  wizRevModified: '(adjusted)',
  wizRevJudgingSkipped: 'Without AI rating – all candidates are contacted',
  wizRevClass: 'Class {{classes}}',
  wizRevNoClass: 'none',
  wizRevListValue: '{{active}} of {{total}} candidates of the preview active · more running',
  wizRevListPending: 'The first candidates are still loading',
  wizRevListDone: '{{active}} of {{total}} candidates of the preview active',
  wizRevListNone: 'No results found',
  wizRevListNotStarted: 'The search has not been started yet',
  wizRevListFailed: 'The search failed',
  wizRevFlow: 'Dynamic flow · {{count}} messages',
  wizRevFlowInmails: ', of which {{count}} InMails',
  wizRevFlowByReaction: 'depending on reaction',
  wizRevFlowPending: 'Dynamic flow · being calculated',
  wizRevRecruitsClients: 'As a service provider',
  wizRevAudienceBoth: 'New + existing',
  wizRevNoteWith: 'Request with message',
  wizRevNoteWithout: 'Request without message',
  wizRevReferral: 'Referral {{bonus}}',
  wizRevLangAuto: 'Language automatic',
  wizRevAgentTitle: 'How the agent works',
  wizRevAgentSubtitle: 'Proven defaults. Only change them if you have a reason.',
  wizRevChange: 'Change',
  wizRevDone: 'Done',
  wizRevSettingAccount: 'Sender',
  wizRevSettingWorkTime: 'Working hours',
  wizRevSettingApprove: 'Approval',
  wizRevSettingRecontact: 'Already contacted',
  wizRevWorkTime0: 'Mon–Fri, 8 am–6 pm',
  wizRevWorkTime1: 'Mon–Fri, 9 am–5 pm',
  wizRevWorkTime2: 'Mon–Sat, 8 am–8 pm',
  wizRevWorkTime3: 'Working hours of the LinkedIn account',
  wizRevWorkTimeAccountSuffix: '(as in the account)',
  wizRevChoose: 'Please choose',
  wizRevApproveHint0: 'You will find the messages awaiting approval under “Manage tasks”.',
  wizRevApproveHint1:
    'SAIA creates and sends your messages exactly as set out in your saved message flow.',
  wizRevRecontactHint:
    'This includes all candidates you contacted yourself via InMail or chat, as well as candidates from other SAIA campaigns.',
  wizRevWorkWindow: '{{days}}, {{hours}} h',
  wizRevWorkWindowNone: 'No overlap with the account’s window – nothing will be sent',
  wizRevAnd: 'and',
  wizRevDayMo: 'Mon',
  wizRevDayTu: 'Tue',
  wizRevDayWe: 'Wed',
  wizRevDayTh: 'Thu',
  wizRevDayFr: 'Fri',
  wizRevDaySa: 'Sat',
  wizRevDaySu: 'Sun',
  wizRevApprove0: 'Approve every message beforehand',
  wizRevApprove1: 'Send messages automatically',
  wizRevSettingApproveContacts: 'Contacts',
  wizRevApproveContacts0: 'Approve every contact before outreach',
  wizRevApproveContacts1: 'Contact judged candidates directly',
  wizRevRecontactNone: 'No restriction',
  wizRevRecontactNever: 'Never contact again',
  wizRevRecontact14: 'After 2 weeks',
  wizRevRecontact28: 'After 4 weeks',
  wizRevRecontact60: 'After 2 months',
  wizRevRecontact90: 'After 3 months',
  wizRevRecontact180: 'After 6 months',
  wizRevRecontactDays: 'After {{days}} days',
  wizRevKeyAutoReply: 'Auto-replies',
  wizRevAutoReplyOn: 'On · {{count}} cases',
  wizRevAutoReplyOff: 'Off',
  wizRevFormalSie: 'Formal address',
  wizRevFormalDu: 'Informal address',
};
export default wizReviewEN;
